export default {
  weAreSis: {
    title: ['We are ', 'SIS'],
    description:
      'SIS Consulting provides services and integrated systems solutions, and business consulting, in line with the main corporate strategies, by means of a highly qualified team. Our experience and commitment reflect the high level of satisfaction and recognition of our clients.',
    button: 'What we do',
  },
}
